import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import hdhomeAnalytics from '@thd-olt-global/hdhome-analytics';
import { GlobalProvider, createGlobalContext } from '@thd-olt-global/global-provider-component';
import Localizer from 'thd-localizer';
import createStore from '../../react/store';
import { App } from '../../react/App';
import '../global/global-styles';

hdhomeAnalytics();
const { store, history } = createStore(window.location.pathname);
let localStore = (window.__GLOBAL_CONTEXT__ && window.__GLOBAL_CONTEXT__.localStore) || {};
const clientSideLocalStore = Localizer.getLocalizedStore();
if (clientSideLocalStore) {
  localStore = {
    ...localStore,
    storeName: clientSideLocalStore.name || localStore.name,
    storeId: clientSideLocalStore.storeId || localStore.storeId,
    localStoreZip: clientSideLocalStore.zipcode || localStore.localStoreZip
  };
}
let localizationStatus = (window.__GLOBAL_CONTEXT__ && window.__GLOBAL_CONTEXT__.localizationStatus) || 'default';
if (Localizer.status.isDefaultLocalized()) {
  localizationStatus = 'default';
} else if (Localizer.status.isAutoLocalized()) {
  localizationStatus = 'auto';
} else if (Localizer.status.isSelfLocalized()) {
  localizationStatus = 'self';
}

const GlobalContext = createGlobalContext(
  {
    adobeCookie: (window.__GLOBAL_CONTEXT__ && window.__GLOBAL_CONTEXT__.adobeCookie) || {},
    cookies: (window.__GLOBAL_CONTEXT__ && window.__GLOBAL_CONTEXT__.cookies) || {},
    location: window.location.hostname,
    localStore,
    localizationStatus,
    request: (window.__GLOBAL_CONTEXT__ && window.__GLOBAL_CONTEXT__.request) || {},
    expConfiguration:
      (window.__GLOBAL_CONTEXT__ && window.__GLOBAL_CONTEXT__.expConfiguration) || {},
    visualNavPromos: (window.__GLOBAL_CONTEXT__ && window.__GLOBAL_CONTEXT__.visualNavPromos) || {}
  }
);

ReactDOM.hydrate(
  <Provider store={store}>
    <GlobalProvider value={GlobalContext}>
      <HelmetProvider>
        <Router history={history}>
          <App history={history} />
        </Router>
      </HelmetProvider>
    </GlobalProvider>
  </Provider>, document.getElementById('root')
);
